import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"
import { useNavigate, useParams } from "react-router"

const { Title, Paragraph } = WebsiteTypography

const DeliveryConfirmedNotice: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const { setIsModalDarkOpen } = useModalDarkContext()
  const navigate = useNavigate()
  const { org } = useParams()

  const handleClose = () => {
    navigate(`${org}/home`)
    setIsModalDarkOpen(false)
  }

  return (
    <Row className={"link-successful-notice-wrapper"} justify={"center"} style={{ marginTop: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Row justify={"center"} style={{ paddingBottom: 24 }}>
          <SvgIcon type={"circled-tick"} color={"green"} />
        </Row>

        <Title level={xxl || xl || lg || md || sm ? 3 : 5} centered className={"form-section-title"}>
          <span className={"w300"}>{"Delivery Already "}</span>
          <span className={"bold"}>{"Confirmed"}</span>
        </Title>

        <Paragraph centered style={{ paddingTop: 24 }} color={"white"} size={xxl || xl || lg || md || sm ? "md" : "sm"}>
          {"This approval item has been successfully delivered."}
        </Paragraph>

        <DividerWithHex marginBottom={32} marginTop={32} />

        <Paragraph centered color={"green"} size={xxl || xl || lg || md || sm ? "md" : "sm"}>
          {
            "If you have any questions, please contact the person who shared this link with you or reach out to the easetech support team."
          }
        </Paragraph>

        <Row justify={"center"} style={{ paddingTop: 40 }}>
          <Col xxl={8} xl={8} lg={8} md={10} sm={14} xs={16}>
            <Button btnType={"primary"} onClick={handleClose} text={"Close"} size={"large"} block />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default DeliveryConfirmedNotice
